const BASE_URL = process.env.REACT_APP_FRONTEND_URL

export const notificationURL: Map<string, string> = new Map([
    ['NEW_ACTIVE_WARNING_TEST', `${BASE_URL}`],
    ['NEW_ACTIVE_WARNING', `${BASE_URL}`],
    ['NEW_INCIDENT_TEST', `${BASE_URL}/incidents/management`],
    ['NEW_INCIDENT', `${BASE_URL}/incidents/management`],
    ['NEW_ACKNOWLEDGEMENT_TEST', `${BASE_URL}/sm/early_warning/acknowledgement`],
    ['NEW_ACKNOWLEDGEMENT', `${BASE_URL}/sm/early_warning/acknowledgement`],

    ['TSUNAMI_SIMULATION_FAILED', `${BASE_URL}/simulations/tsunami`],
    ['TSUNAMI_SIMULATION_COMPLETED', `${BASE_URL}/simulations/tsunami`],

    ['FLOOD_SIMULATION_FAILED', `${BASE_URL}/simulations/flood`],
    ['FLOOD_SIMULATION_COMPLETED', `${BASE_URL}/simulations/flood`],
])